import { HTMLAttributes, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { useLenis, useScrollbar } from '@/contexts/lenis'
import { useLayoutStore } from '@/store/layout'

import { cn } from '@/lib/utils'

export type ScrollbarProps = HTMLAttributes<HTMLDivElement>

const Scrollbar = ({ className, ...props }: ScrollbarProps) => {
  const router = useRouter()
  const { lenis } = useLenis()
  const [active, setActive] = useState(true)
  const [track, thumb, needsScrollbar, resize] = useScrollbar(lenis)

  useEffect(() => {
    const unsubscribe = useLayoutStore.subscribe(
      (state) => state.menuOpen,
      (menuOpen) => setActive(!menuOpen)
    )

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (!lenis) return
    lenis.resize()
    resize()
  }, [router.asPath, lenis, resize])

  return (
    <div
      className={cn(
        'group fixed bottom-0 right-0 top-0 z-scrollbar w-[1.2rem] touch:hidden',
        {
          visible: needsScrollbar,
          invisible: !needsScrollbar || !active
        },
        className
      )}
      {...props}
    >
      <div ref={track} className="relative h-full w-full">
        <div
          ref={thumb}
          className={cn(
            'absolute left-0 top-0 w-full',
            'before:absolute before:bottom-[.2rem] before:right-[.2rem] before:top-[.2rem] before:w-[.4rem] before:rounded-full before:bg-surface-primary-light dark:before:bg-surface-primary-dark'
          )}
        />
      </div>
    </div>
  )
}

export default Scrollbar
